import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { GameCenterComponentGridAreas } from '../../styles';

export const TeamStatsContainer = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium}
    display: flex;
    flex-direction: column;
    grid-area: ${GameCenterComponentGridAreas.teamStats};

    ${BaseStyle.Mixins.screenSizes.large} {
        padding: 0 24px;
    }
`;

export const HeaderTeamLogoContainer = styled.div`
    ${BaseStyle.Mixins.gaps.large}
    display: flex;
    flex-direction: column;
`;

export const HeaderContainer = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    flex: 1;
    flex-direction: column;
`;

export const HeaderName = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['20b']}
`;

export const SubHeader = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
    color: ${({ theme }) => theme.Text.secondary};
`;

export const TeamContainer = styled.div`
    ${BaseStyle.Mixins.gaps.small}

    align-items: center;
    display: flex;
    flex: 1;
    justify-content: space-between;

    img {
        height: 32px;
        width: 48px;
    }

    .team-display-container:nth-child(2) {
        .team-display {
            justify-content: end;
        }
    }
`;
